<sdps-divider variation="secondary"></sdps-divider>
<div class="space-between">
  <span id="section-title">Transaction details</span>
  <a
    *ngIf="isIraTransaction"
    id="client-ira-agreement-link"
    (click)="displayIraAgreementModal()"
  >View client IRA agreement</a>
</div>
<mm-banners
  id="it-service-error-banner"
  *ngIf="showServerError"
  [bannerText]="[serverErrorText]"
  [type]="'error'"
></mm-banners>
<mm-banners
  id="it-download-request-form-error-banner"
  *ngIf="downloadRequestFormError"
  [type]="'error'"
  [downloadCheckJournalRequestForm]="true"
></mm-banners>
<mm-banners
  *ngIf="showWarning"
  [bannerText]="[warningText]"
  [type]="'warning'"
></mm-banners>
<form [formGroup]="itInputForm">
  <mm-it-multiple-to-account
    [parentForm]="itInputForm"
    [editFormDetails]="editFormDetails"
    [disabled]="(useStandingAuth$ | async) ?? false"
    [toAccountLimit]="10"
    [info$]="itInfo$"
    [clearToAccounts]="deleteToAccounts.asObservable()"
    (resetForm)="resetForm()"
    (toAccounttoDelete)="toAccounttoDeleteEvent($event)"
    [downloadRequestFormError]="downloadRequestFormError"
    [isRecurringTransaction]="isRecurringTransaction"
    [datePickerControlName]="controlNames.processDate"
    [sourcePtrsFieldsExist]="sourcePtrsFieldsExist"
    *ngIf="isInputCallFinishedOrEditFlow"
  ></mm-it-multiple-to-account>
  <div class="row">
    <fieldset>
      <div class="big-bottom-spacer">
        <mm-recurring-frequency-selector
          *ngIf="isRecurringTransaction"
          [parentForm]="recurringFieldsFormGroup"
          [frequencyList]="this.itInfo.recurringFields.frequencyList"
        ></mm-recurring-frequency-selector>
      </div>
      <div *ngIf="isPositionsTransaction(transferType); else notPositionsTransaction">
        <div class="input-container">
          <span class="sdps-text-nowrap extra-small-bottom-spacer">
            <label>Process Date</label>
            <mm-tooltip
              [position]="'right'"
              [containsLink]="false"
              id="multiplepositions-process-date-tooltip"
            >
              <tooltip-content>
                <div>{{positionProcessDateToolTipMessage}}</div>
              </tooltip-content>
              <tooltip-trigger-element>
                <sdps-icon
                  color="active"
                  type="functional"
                  name="info"
                  size="small"
                ></sdps-icon>
              </tooltip-trigger-element>
            </mm-tooltip>
          </span>
          <input
            type="text"
            value={{currentDate()}}
            disabled
            class="sdps-input sdps-input--small"
            id="border_Color"
          >
        </div>
      </div>
      <ng-template #notPositionsTransaction>
        <mm-date-picker-control
          [label]="processDateLabel"
          formControlName="processDate"
          [parentForm]="itInputForm"
          [id]="'process-date-picker'"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [disableWeekends]="!isRecurringTransaction"
          [formControlValidators]="!isRecurringTransaction ? processDateValidators : recurringProcessDateValidators"
          [disableDateSelect]="disableDateSelect"
        ></mm-date-picker-control>
      </ng-template>
      <div
        *ngIf="isRecurringTransaction"
        formGroupName="recurringFieldsFormGroup"
      >
        <mm-date-picker-control
          *ngIf="recurringFrequency?.value === 'SEMIMTH'"
          formControlName="secondProcessDate"
          [label]="secondProcessDateLabel"
          [parentForm]="recurringFieldsFormGroup"
          [minDate]="minDate"
          [disableWeekends]="!isRecurringTransaction"
          [formControlValidators]="secondProcessDateValidators"
          (newValueEvent)="onSecondProcessDateChange($event)"
          [id]="'second-process-date-picker'"
        ></mm-date-picker-control>
        <mm-date-picker-control
          *ngIf="recurringFrequency?.valid"
          formControlName="endDate"
          [label]="endDateLabel"
          [minDate]="minDate"
          [disableWeekends]="false"
          [formControlValidators]="endDateValidators"
          [showOptionalLabel]="true"
          [parentForm]="recurringFieldsFormGroup"
          (newValueEvent)="onEndDateChange($event)"
          [id]="'end-date-picker'"
        ></mm-date-picker-control>
      </div>
    </fieldset>
  </div>
  <div class="row">
    <fieldset>
      <div id="costBasisMethod">
        <mm-radio-control
          *ngIf="this.showCostBasisMethod"
          [parentForm]="itInputForm"
          [radioModel]="costBasisMethodModel"
        ></mm-radio-control>
      </div>
    </fieldset>
  </div>
  <sdps-divider
    variation="secondary"
    class="extra-small-bottom-spacer"
  ></sdps-divider>
  <positions-table-multiple-to-account
    [reviewConfirmationPage]="false"
    *ngIf="isPositionsTransaction(transferType)"
    [displayPositionsWarningPhase2]="displayPositionsWarningPhase2"
    [maxLotsWarningMessage]="maxLotsWarningMessage"
    [isOneTimeTotalDist]="isOneTimeTotalDist"
    [maxLotsWarning]="maxLotsWarning"
  ></positions-table-multiple-to-account>
  <br>
  <fieldset>
    <div class="transaction-details-fields">
      <mm-it-multiple-cash-inputs
        *ngIf="transferType !=='positions'"
        [amountType]="cashAmounts"
        [autoCalculateRmd$]="autoCalculateRmd$"
        [parentForm]="itInputForm"
        [amountTypeSelection]="amountTypeSelection"
      ></mm-it-multiple-cash-inputs>
      <mm-it-multiple-tax-withholdings
        *ngIf="isIraTransaction"
        [parentForm]="itInputForm"
        [editFormDetails]="editFormDetails"
      ></mm-it-multiple-tax-withholdings>
      <mm-it-multiple-trust-fields
        id="multipleitTransactionDetails_ trustFields"
        *ngIf="showFromTrustFields"
        [parentForm]="itInputForm"
        [displayFromTrustFields]="true"
        [datePickerControlName]="controlNames.processDate"
        #multipleitTransactionDetails_trustFields
      ></mm-it-multiple-trust-fields>
    </div>
  </fieldset>
</form>
<cashiering-ira-agreement-modal [showModal]="showCashieringIRAAgreementModal"></cashiering-ira-agreement-modal>